module.exports = __webpack_public_path__ + "img/li.01fe4eb0.jpg";